export const APP_ENV = window.APP_ENV;
export const production = APP_ENV === 'production';
export const local = APP_ENV === 'local';
